<template>
  <div id="order-comfirm-infos">
    <div class="info-header">
      <div class="header-title">出行信息</div>
      <div class="header-right">
        <div class="effect-date-box" v-if="order.need_effect_date">
          <div class="date-label">签证生效日期</div>
          <holiday-date-picker
            :depart-date="otherOrderData.effect_date"
            v-bind:min-disabled-date="new Date()"
            :selected-display-none="true"
            :show-early="false"
            tips="该签证需指定生效日期，出行日期不得早于指定生效日期"
            :show-tips="true"
            :hide-week="true"
            :hide-holiday="true"
            v-on:input="changeEffectDate">
            <div class="holiday-date-content" slot-scope="slotProps">
              <span v-if="slotProps.date">{{ dateUtils.formatDateWithzeroWithWeek(slotProps.date) }}</span>
              <span v-else>请选择</span>
              <img class="down-icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
            </div>
          </holiday-date-picker>
        </div>
        <div class="separate" v-if="order.need_effect_date"></div>
        <div class="depart-date-box">
          <div class="date-label">预计出行日期</div>
          <holiday-date-picker
            :depart-date="otherOrderData.depart_date"
            v-bind:min-disabled-date="disabledDate"
            :holiday-date-arr="holidayArr"
            :selected-display-none="true"
            :show-early="true"
            tips="您的出行日期过早，在规定的办理时长内无法出签，请更改出行日期"
            :show-tips="departDatePast"
            v-on:input="changeDepartDate"
          >
            <div class="holiday-date-content" slot-scope="slotProps">
              <span v-if="slotProps.date">{{ dateUtils.formatDateWithzeroWithWeek(slotProps.date) }}</span>
              <span v-else>请选择</span>
              <img class="down-icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
            </div>
          </holiday-date-picker>
        </div>
      </div>
    </div>
    <div class="applicant-info-box">
      <div class="product-info-box">
        <img class="product-flag" :src="order.national_flag_img" alt="">
        <div class="product-name">{{order.product_name}}</div>
        <div class="product-price" v-if="order.applicant && order.applicant.length > 0">
           <!-- 有特价时显示特价 -->
          <confirm-module-price-text
            :price="order.special_price || order.applicant[0].sell_price"
            :length="order.applicant.length"
          ></confirm-module-price-text>
         

        </div>
      </div>
      <div class="applicant-list" v-if="order.applicant">
        <div class="applicant-item" v-for="(applicant, applicantIndex) in applicantExpand ? order.applicant : order.applicant.slice(0, 3)" :key="applicantIndex">
          <img @click="deleteApplicant(applicantIndex)" class="delete-icon" src="https://o.666visa.cn/static/ssqpeer/order/delete-icon.png" alt="">
          <div class="applicant-name" :class="{'is-fliggy': order.ota_info}">{{applicant.applicant_name}}<span v-if="order.ota_info">({{`${applicant.surname_pinyin} ${applicant.given_name_pinyin}`}})</span></div>
          <div class="applicant-identity">{{applicant.identity}}</div>
          <a class="applicant-detail" @click="goCheckOutDetail(applicant.order_applicant_id)">查看资料</a>
        </div>

        <div class="expand-box" @click="applicantExpand =! applicantExpand" v-if="order && order.applicant && order.applicant.length > 3">
          <div class="expand-text" v-if="applicantExpand">收起</div>
          <div class="expand-text" v-else>展开剩余 {{order.applicant.length - 3}} 人</div>
          <img class="down-icon" :class="{expand: applicantExpand }" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
        </div>
      </div>
    </div>
    <div class="tips">温馨提醒：出签之前预订机票、酒店可能带来风险</div>

    
  </div>
</template>

<script>
import visaDialog from '../../../components/common/modals/visa-dialog/visa-dialog';
import holidayDatePicker from '../../../components/holiday-date-picker';
import Http from '../../../libs/http';
import dateUtils from '../../../libs/date-util';
import ConfirmModulePriceText from './base/confirm-module-price-text.vue';

export default {
  name: 'order-comfirm-infos',
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {
    holidayDatePicker,
    visaDialog,
    ConfirmModulePriceText,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 日历不可选日期
    disabledDate: {
      type: String,
      required: true,
      default: '',
    },

    // 放假数组
    holidayArr: {
      type: Array,
      required: true,
      default: () => ([]),
    },

    // 订单
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    departDatePast: {
      type: Boolean,
      default: false,
    },
    effectDatePast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateUtils,
      otherOrderData: this.value,
      applicantExpand: false,
      deleteDialog: false,
      deleteLoading: false,
    };
  },
  methods: {

    // 统一处理
    changeModelData() {
      this.$emit('input', this.otherOrderData);
    },

    // 改变出行日期
    changeDepartDate(date) {
      const depart_date = date.format('yyyy-MM-dd');

      Http.post('/order_depart_date_update', { user_order_id: this.order.user_order_id, depart_date }).then(() => {
        this.otherOrderData.depart_date = date;
        this.changeModelData();
        this.$emit('changeDepartDate');
      });
    },

    // 改变生效日期
    changeEffectDate(date) {
      const effect_date = date.format('yyyy-MM-dd');

      Http.post('/order_effect_date_submit', {
        order_id: this.order.user_order_id,
        effect_date,
      }).then(() => {
        this.otherOrderData.effect_date = date;
        this.changeModelData();
        this.$emit('changeEffectDate');
      }).catch((err) => {
        console.log(err);
        this.$message.error('设置签证生效日期失败，请刷新页面稍后再试');
      });
    },

    // 查看资料
    goCheckOutDetail(aid) {
      MtaH5.clickStat('payvisaorder0lookinfo');
      const { href } = this.$router.resolve({
        name: 'reupload',
        params: {
          oid: this.order.user_order_id,
          aid,
          back: true,
        },
        query: {
          canModify: 1,
        },
      });
      window.open(href, '_blank');
    },

    // 删除申请人
    deleteApplicant(index) {
      const deleteApplicant = this.order.applicant[index];
      if (this.order.applicant.length === 1) {
        return this.$message({
          message: '不能删除全部申请人',
          type: 'warning',
        });
      }
      this.$confirm('确认删除该申请人', '删除申请人', {
        confirmButtonText: '　是　',
        cancelButtonText: '　否　',
        type: 'warning',
      }).then(() => {
        Http.post('/applicant_delete', {
          user_order_id: this.order.user_order_id,
          applicant_id_set: [deleteApplicant.order_applicant_id],
        }).then(() => {
          this.order.applicant.splice(index, 1);
          this.$emit('applicantDelete');
          this.$message({
            message: '删除成功',
            type: 'success',
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
      }).catch((e) => {
        if (e) console.log(e);
      });

    },

    modalVisibleSync(val) {
      this.deleteDialog = val;
    },
  },
  watch: {
    value(newVal) {
      this.otherOrderData = newVal;
    },
  },
};
</script>



<style lang="less" scoped>
@import '../../../assets/less/variable.less';

#order-comfirm-infos {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0 24px 16px 24px;
  line-height: 1;
  .info-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    .header-title{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
    }
    .header-right{
      display: flex;
      align-items: center;
      .effect-date-box, .depart-date-box{
        display: flex;
        align-items: center;
        .date-label{
          white-space: nowrap;
          color: #5F666E;
          font-size: 14px;
          margin-right: 8px;
        }
        .holiday-date-content{
          font-size: 14px;
          color: #599FFF;
          font-weight: 600;
          display: flex;
          align-items: center;
          cursor: pointer;
          .down-icon{
            width: 14px;
            height: 14px;
            margin-left: 4px;
          }
        }
      }
      .separate{
        width: 1px;
        height: 14px;
        background: #DEE2E6;
        margin: 0 24px;
      }
    }
  }
  .applicant-info-box{
    background: #FAFBFC;
    border-radius:2px;
    .product-info-box{
      height: 60px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E9EEF2;
      padding: 0 24px;
      .product-flag{
        flex-shrink: 0;
        width: 24px;
        margin-right: 12px;
      }
      .product-name{
        flex-grow: 1;
        color: #2F333D;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-price{
        flex-shrink: 0;
      }
    }
    .applicant-list{
      padding: 0 24px 0 64px;
      .applicant-item{
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #DEE2E6;
        &:last-child{
          border-bottom: none;
        }
        .delete-icon{
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          margin-right: 12px;
          cursor: pointer;
        }
        .applicant-name{
          color: #2F333D;
          font-size: 14px;
          line-height: 16px;
          min-width: 70px;
          max-width: 70px;
          margin-right: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.is-fliggy{
            min-width: 90px;
            max-width: 600px;
            margin-right: 20px;
          }
        }
        .applicant-identity{
          flex-grow: 1;
          color: #5F666E;
          font-size: 14px;
        }
        .applicant-detail{
          font-size: 14px;
          color: #599FFF;
          display: flex;
          align-items: center;
          &::after{
            content: "";
            width: 12px;
            height: 12px;
            background: url(https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png) no-repeat center / 100% 100%;
            margin-left: 4px;
          }
        }
      }
      .expand-box{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #599FFF;
        font-size: 14px;
        padding: 16px 0;
        .down-icon{
          width: 14px;
          height: 14px;
          margin-left: 8px;
          transition: 0.15s all;
          &.expand{
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .tips{
    margin-top: 16px;
    color: #91999F;
    font-size: 14px;
  }

  


  .visa-dialog-modal{
    .delete-dialog-applicant-list{
      padding: 20px 0px 15px;
      border-bottom: 1px solid #f0f0f0;
      .list-title{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333333;
        padding: 0px 50px;
      }
      .list-body{
        margin-top: 15px;
        padding-top: 5px;
        padding-right: 10px;
        max-height: 150px;
        overflow-y: auto;
        margin-left: 50px;
        margin-right: 40px;
        .item-box{
          display: flex;
          margin-bottom: 15px;
          .checkbox{
            flex:1;
            .el-checkbox__label{
              color: red;
            }
          }
          .identity{
            font-size: 14px;;
	          color: #aaaaaa;
          }
        }
        div:last-child {
          margin-bottom: 2px;
        }
      }

    }
    .footer-box{
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-box{
        width: 140px;
        height: 40px;
        border-radius: 4px;
        font-size: 16px;
        &.cancle-btn{
          border: solid 1px #cfcfcf;
          color: #777777;
        }
        &.delete-btn{
          background-color: #5e9be1;
          border: none;
          color: #ffffff;
        }
      }
    }
  }
}
</style>

<style lang="less">
div#order-comfirm-infos {
  .el-input__inner {
    height: 38px;
  }
  .visa-dialog-modal{
    .el-dialog{
      top: 35% !important;
    }
  }
  .visa-dialog-modal{
    .item-box{
      .checkbox{
        .el-checkbox__label{
          color: #333333;
          padding-left: 10px;
        }
      }
    }
  }
  .footer-box{
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-comfirm-infos.vue